import React from 'react';
import styled from 'styled-components';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';

import ChalkboardInput from 'components/Input/ChalkboardInput';
import Button from 'components/Button/Button';
import Field from 'components/Field/Field';
import Label from 'components/Label/Label';
import { Chalkboard, ChalkboardText } from 'components/ChalkBoard/ChalkBoard';
import { setRole } from 'reducers/auth';
import avatars from 'components/Avatar/avatars';
import media from 'components/media/media';

import LoginService from 'services/LoginService';

import { QuickLogin, QuickLoginWrapper } from './QuickLogin';

const background = require('assets/primary-interface/Login/Background.svg');

const Center = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  position: relative;
  width: 100vw;
  height: 100vh;
  background-image: url(${background});
  background-size: cover;
`;

const Section = styled.div`
  padding: 15px 0;
  width: 100%;
`;

const LogoWrap = styled.div`
  position: absolute;
  padding-bottom: 16px;
  padding-top: 16px;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  pointer-events: none;
`;
LogoWrap.displayName = 'LogoWrap';
const Logo = styled.img`
  width: 15vw;
  box-shadow: 0 0 0 0 black;
  ${media.portrait`
    width: 25vw;
  `}
  ${media.mobile`
    width: 40vw;
  `}
`;
Logo.displayName = 'Logo';
Logo.defaultProps = { src: require('assets/general/logo.svg') };

const ACTIVE = true;

class Login extends React.Component {
  constructor() {
    super();

    this.state = {
      username: '',
      password: '',
      quickLogins: []
    };
  }
  async componentDidMount() {
    try {
      this.setState({
        quickLogins: await LoginService.getQuickLogins(ACTIVE)
      });
    } catch (e) {
      console.error(e.message, e);
    }
  }
  handleChange = (e) => {
    const { name, value } = e.target;

    this.setState({ [name]: value, error: '' });
  };
  handleQuickLogin = (UserID) => async (e) => {
    try {
      this.handleRedirect(await LoginService.quickLogin(UserID));
    } catch (e) {
      console.error(e.message, e);
    }
  };
  login = async () => {
    try {
      if (this.state.username && this.state.password) {
        this.handleRedirect(await LoginService.login(this.state.username, this.state.password));
      } else {
        this.setState({ error: 'Please enter both a username and password' });
      }
    } catch (e) {
      console.error('No data returned:', e.message);
    }
  };
  handleRedirect = (role) => {
    let url = LoginService.getLoginPath(role)
    if (!!url) {
      this.props.setRole(role);
      return this.props.push(url);
    } else {
      this.setState({ error: 'Incorrect username and/or password', password: '' });
      return;
    }
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.login();
  };
  render() {

    const { username, password } = this.state;

    let token = sessionStorage.getItem('token');

    if (token && token !== 'undefined') {
      let obj = JSON.parse(atob(token.split('.')[1]));
      let now = Date.now();
      let expires = obj.exp * 1000;
      if (now > expires) {
        sessionStorage.clear();
      } else {
        setTimeout(this.handleRedirect, 0, obj.rl);
      }
    }

    return (
      <Center>
        <Chalkboard style={{ zIndex: 3 }}>
          <Section>
            <ChalkboardText>Tusitawi</ChalkboardText>
          </Section>
          <QuickLoginWrapper>
            {this.state.quickLogins.map(({ Avatar, FirstName, UserID }, i) => (
              <QuickLogin key={UserID} avatar={avatars[Avatar]} onClick={this.handleQuickLogin(UserID)}>{FirstName}</QuickLogin>
            ))}
          </QuickLoginWrapper>
          <Section style={{ maxWidth: '256px' }}>
            <form onSubmit={this.handleSubmit}>
              <Field>
                <Label chalkboard center>Username</Label>
                <ChalkboardInput autoFocus name="username" type="text" onChange={this.handleChange} value={username} />
              </Field>
              <Field>
                <Label chalkboard center>Password</Label>
                <ChalkboardInput name="password" type="password" onChange={this.handleChange} value={password} />
              </Field>
              {this.state.error && (<Label style={{ marginTop: '6px', fontSize: '13pt' }} chalkboard center>{this.state.error}</Label>)}
              <Field style={{ display: 'flex', justifyContent: 'center' }}>
                <Button style={{width: '128px', color: '#28483a', fontSize: '25px'}} type="submit"><i className="fas fa-arrow-right" /></Button>
              </Field>
            </form>
          </Section>
        </Chalkboard>
        <LogoWrap>
          <Logo />
        </LogoWrap>
      </Center>
    );
  }
}

export default connect(null, dispatch => ({
  push: url => dispatch(push(url)),
  setRole: role => dispatch(setRole(role))
}))(Login);



// WEBPACK FOOTER //
// ./src/views/LoginView/LoginView.js